import { cn } from "@/lib/utils";
import type { RowChip } from "./documentRowDecorations";

const CHIP_TONES: Record<RowChip["tone"], string> = {
  added: "border-emerald-300 bg-emerald-50 text-emerald-700",
  changed: "border-amber-300 bg-amber-50 text-amber-800",
  removed: "border-red-300 bg-red-50 text-red-700",
};

/** The chip beside a row's name. */
export function RowChipBadge({ chip }: { chip: RowChip }) {
  return (
    <span
      title={chip.title}
      aria-label={chip.title ?? chip.label}
      data-testid="row-chip"
      className={cn(
        "inline-flex flex-shrink-0 items-center rounded-full border px-1.5 py-px text-[10px] font-medium leading-4",
        CHIP_TONES[chip.tone]
      )}
    >
      {chip.label}
    </span>
  );
}
